// core
import { Component, OnInit, Input  } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { SVG_OPEN_ICONS } from './open-svg-icon.constants';
import { SVG_HOLLARD_ICONS } from './open-svg-hollard-icon.constants';
import { SVG_HUDDLE_ICONS } from './open-svg-huddle-icon.constants';
import { SVG_OPEN_LARGE_ICONS } from './open-svg-icon-large-icon.constants';
import { SVG_WHITE_LABEL_ICONS } from './open-svg-icon-white-label-icon.constants';
import { SVG_MISC_ICONS } from './open-svg-icon-misc.constants';
import { SVG_BUPA_ICONS } from './open-svg-bupa-icon.constants';
import { SVG_AVIOS_ICONS } from './open-svg-avios-icon.constants';
import { SVG_CUPRA_ICONS } from './open-svg-cupra-icon.constants';
import { SVG_DEFAQTO_ICONS } from './open-svg-defaqto-icon.constants';

@Component({
  selector: 'open-svg-icon',
  templateUrl: './open-svg-icon.component.html',
  styleUrls: ['./open-svg-icon.component.scss']
})
export class OpenSvgIconComponent implements OnInit {
  @Input() name: any;
  @Input() class: any;
  icon?: any;
  constants: Array<any> = [
    SVG_WHITE_LABEL_ICONS,
    SVG_HOLLARD_ICONS,
    SVG_HUDDLE_ICONS,
    SVG_OPEN_ICONS,
    SVG_OPEN_LARGE_ICONS,
    SVG_MISC_ICONS,
    SVG_BUPA_ICONS,
    SVG_AVIOS_ICONS,
    SVG_CUPRA_ICONS,
    SVG_DEFAQTO_ICONS
  ];

  constructor(private domSanitizer: DomSanitizer) { }

  ngOnInit(): void {
    if (this.name) {
      for (let key in this.constants) {
        if (this.constants[key][this.name]) {
          this.icon = this.domSanitizer.bypassSecurityTrustHtml(this.constants[key][this.name]);
        }
      }
    }
  }
}
